// ボタンと画像の要素を取得
const productImages = document.querySelectorAll('.product-variant-image');
const productThumbImages = document.querySelectorAll('.thumbnail-list__item');
const productColorBtn = document.querySelectorAll(
  '.product-form__input input[type="radio"][name="カラー"]'
);
const productModalImages = document.querySelectorAll('.product-modal-image');
const variantTitle = document.getElementById('variantTitle');

// カラー切り替えの処理
const showSelectedColorImages = () => {
  productColorBtn.forEach(btn => {
    if (btn.checked) {
      variantTitle.innerHTML = `: ${btn.dataset.title}`;
      if (window.innerWidth <= 749) {
        productImages.forEach(image => {
          const imageColor = image.getAttribute('data-color');
          if (imageColor === btn.value) {
            image.style.display = 'block';
          } else {
            image.style.display = 'none';
          }
        });
      }
      productModalImages.forEach(image => {
        const imageColor = image.alt;
        if (imageColor === btn.value) {
          image.style.display = 'block';
        } else {
          image.style.display = 'none';
        }
      });
      productThumbImages.forEach(image => {
        const imageColor = image.getAttribute('data-color');
        if (imageColor === btn.value) {
          image.style.display = 'block';
        } else {
          image.style.display = 'none';
        }
      });
    }
  });
};

// 読み込み時に処理を実行
window.addEventListener('DOMContentLoaded', showSelectedColorImages);

// カラー選択時に処理を実行
productColorBtn.forEach(btn => {
  btn.addEventListener('click', showSelectedColorImages);
});
